(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5395],{

/***/ 24277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ BreadCrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./components/BreadCrumbs/breadCrumbs.module.sass
var breadCrumbs_module = __webpack_require__(75685);
var breadCrumbs_module_default = /*#__PURE__*/__webpack_require__.n(breadCrumbs_module);
// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
;// CONCATENATED MODULE: ./components/BreadCrumbs/BreadCrumbs.jsx







var BreadCrumbs = function(param) {
    var routeCrumbs = param.routeCrumbs, url = param.url;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (breadCrumbs_module_default()).wrapper,
        itemScope: true,
        itemType: "https://schema.org/BreadcrumbList",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (breadCrumbs_module_default()).overflowWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (breadCrumbs_module_default()).crumb,
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        itemProp: "name",
                        className: (0,classcat/* default */.Z)([
                            (breadCrumbs_module_default()).home,
                            (0,_define_property/* default */.Z)({}, (breadCrumbs_module_default()).homeBf, url === "black_friday"), 
                        ]),
                        children: url === "black_friday" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                name: "common/bfHomePage",
                                width: 10,
                                height: 10
                            }),
                            itemProp: "item"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                name: "common/HomePage",
                                width: 16,
                                height: 16
                            }),
                            itemProp: "item"
                        })
                    })
                }),
                routeCrumbs.map(function(i, id) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        itemProp: "itemListElement",
                        itemScope: true,
                        itemType: "https://schema.org/ListItem",
                        className: (breadCrumbs_module_default()).point,
                        children: url === "black_friday" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            itemProp: "item",
                            href: i.link,
                            className: (breadCrumbs_module_default()).crumb,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    itemProp: "name",
                                    className: id === routeCrumbs.length - 1 ? (breadCrumbs_module_default()).currentBf : (breadCrumbs_module_default()).activeBf,
                                    children: i.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    itemProp: "position",
                                    content: id + 1
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            itemProp: "item",
                            href: i.link,
                            className: (breadCrumbs_module_default()).crumb,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    itemProp: "name",
                                    className: id === routeCrumbs.length - 1 ? (breadCrumbs_module_default()).current : (breadCrumbs_module_default()).active,
                                    children: i.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    itemProp: "position",
                                    content: id + 1
                                })
                            ]
                        })
                    }, id);
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/BreadCrumbs/index.js



/***/ }),

/***/ 98796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* reexport */ MainGallery; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Carousel/slider.module.sass
var slider_module = __webpack_require__(77798);
var slider_module_default = /*#__PURE__*/__webpack_require__.n(slider_module);
// EXTERNAL MODULE: ./hooks/useEmblaSlider.js
var useEmblaSlider = __webpack_require__(21471);
// EXTERNAL MODULE: ./components/Image/Image.jsx
var Image = __webpack_require__(49028);
;// CONCATENATED MODULE: ./components/Carousel/Carousel.jsx





/**
 * Каруселька.
 * Всегда нужно оборачивать в Провайдер
 */ var Carousel = function(param) {
    var _data = param.data, data = _data === void 0 ? [] : _data;
    var ref = (0,useEmblaSlider/* useEmblaSlider */.r)(), ref1 = ref.ref, current = ref.current;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (slider_module_default()).embla,
        ref: ref1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (slider_module_default()).emblaContainer,
                children: data.map(function(param) {
                    var url = param.url, description = param.description;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (slider_module_default()).emblaSlide,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            src: url.src,
                            srcSet: url.srcset,
                            alt: description,
                            loading: "lazy"
                        })
                    }, description);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (slider_module_default()).current,
                children: [
                    current + 1,
                    " из ",
                    data.length
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Carousel/index.js


// EXTERNAL MODULE: ./components/CruisePageComponents/MainGallery/maingallery.module.sass
var maingallery_module = __webpack_require__(33903);
var maingallery_module_default = /*#__PURE__*/__webpack_require__.n(maingallery_module);
// EXTERNAL MODULE: ./components/OpenLigtBox/openLightBox.module.sass
var openLightBox_module = __webpack_require__(70833);
var openLightBox_module_default = /*#__PURE__*/__webpack_require__.n(openLightBox_module);
;// CONCATENATED MODULE: ./components/OpenLigtBox/OpenLightBox.jsx



var OpenLightBox = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: (openLightBox_module_default()).openLightBox,
        onClick: onClick,
        children: "Показать все фотографии"
    });
};
/* harmony default export */ var OpenLigtBox_OpenLightBox = (OpenLightBox);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/embla-carousel-react/embla-carousel-react.esm.js
var embla_carousel_react_esm = __webpack_require__(25585);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useKey.js + 1 modules
var useKey = __webpack_require__(26126);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useLockBodyScroll.js
var useLockBodyScroll = __webpack_require__(81341);
// EXTERNAL MODULE: ./components/GalleryModal/gallerymodal.module.sass
var gallerymodal_module = __webpack_require__(26819);
var gallerymodal_module_default = /*#__PURE__*/__webpack_require__.n(gallerymodal_module);
// EXTERNAL MODULE: ./components/GalleryModal/components/Arrows/Arrows.jsx
var Arrows = __webpack_require__(86318);
// EXTERNAL MODULE: ./components/Badge/index.js + 1 modules
var Badge = __webpack_require__(92558);
// EXTERNAL MODULE: ./components/Comment/index.js + 1 modules
var Comment = __webpack_require__(26167);
// EXTERNAL MODULE: ./hooks/useLimitList.js
var useLimitList = __webpack_require__(99905);
// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
;// CONCATENATED MODULE: ./components/GalleryModal/GalleryModal.jsx


















// import { YaAndGaCruisePage } from '../../lib/YaAndGaHelper';
var Hover = function(_param) /*#__PURE__*/ {
    var open = _param.open, props = (0,_object_without_properties/* default */.Z)(_param, [
        "open"
    ]);
    return (0,jsx_runtime.jsx)("div", (0,_object_spread/* default */.Z)({
        className: (0,classcat/* default */.Z)([
            (gallerymodal_module_default()).overlay,
            (0,_define_property/* default */.Z)({}, (gallerymodal_module_default()).open, open)
        ])
    }, props));
};
var Thumb = function(param) {
    var selected = param.selected, onClick = param.onClick, imgSrc = param.imgSrc, description = param.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classcat/* default */.Z)([
            (gallerymodal_module_default()).emblaSlide,
            (gallerymodal_module_default()).emblaSlideThumb,
            (0,_define_property/* default */.Z)({}, (gallerymodal_module_default()).isSelected, selected), 
        ]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: onClick,
            className: (0,classcat/* default */.Z)([
                (gallerymodal_module_default()).emblaSlideInner,
                (gallerymodal_module_default()).emblaSlideInnerThumb
            ]),
            type: "button",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                className: (gallerymodal_module_default()).emblaSlideThumbnail,
                src: imgSrc.src,
                srcSet: imgSrc.srcset,
                alt: description !== null && description !== void 0 ? description : "",
                loading: "lazy",
                title: description !== null && description !== void 0 ? description : ""
            })
        })
    });
};
var GalleryModal = function(param) {
    var tmp = param.category, ref = tmp === void 0 ? {
        name: "",
        type: ""
    } : tmp, name = ref.name, type = ref.type, maxi = param.maxi, mini = param.mini, _reviews = param.reviews, reviews = _reviews === void 0 ? [] : _reviews, activeImg = param.activeImg, onClose = param.onClose, isMobile = param.isMobile, onCloseAction = param.onCloseAction, onActionClose = param.onActionClose, onNextArrow = param.onNextArrow, onPrevArrow = param.onPrevArrow, onArrowPrev = param.onArrowPrev, onArrowNext = param.onArrowNext, onClickImg = param.onClickImg, onImgClick = param.onImgClick, onClickMore = param.onClickMore, onMoreClick = param.onMoreClick;
    var ref1 = (0,react.useState)(activeImg), selectedIndex = ref1[0], setSelectedIndex = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,embla_carousel_react_esm/* default */.Z)({
        containScroll: "keepSnaps",
        selectedClass: "",
        dragFree: true,
        startIndex: activeImg
    }), 2), thumbViewportRef = ref2[0], emblaThumbs = ref2[1];
    var ref3 = (0,useLimitList/* useLimitList */.U)({
        count: reviews.length
    }), show = ref3.show, isCanShowMore = ref3.isCanShowMore, onShowMore = ref3.onShowMore;
    var ref4 = (0,react.useState)(false), prevBtnEnabled = ref4[0], setPrevBtnEnabled = ref4[1];
    var ref5 = (0,react.useState)(false), nextBtnEnabled = ref5[0], setNextBtnEnabled = ref5[1];
    var isOpen = activeImg !== null;
    var isSidebar = reviews.length > 0;
    var scrollPrev = (0,react.useCallback)(function() {
        return emblaThumbs && emblaThumbs.scrollPrev();
    }, [
        emblaThumbs
    ]);
    var scrollNext = (0,react.useCallback)(function() {
        return emblaThumbs && emblaThumbs.scrollNext();
    }, [
        emblaThumbs
    ]);
    var onThumbClick = (0,react.useCallback)(function(index) {
        if (!emblaThumbs) return;
        if (emblaThumbs.clickAllowed()) emblaThumbs.scrollTo(index);
    }, [
        emblaThumbs
    ]);
    var onSelect = (0,react.useCallback)(function() {
        if (!emblaThumbs) return;
        setSelectedIndex(emblaThumbs.selectedScrollSnap());
        setPrevBtnEnabled(emblaThumbs.canScrollPrev());
        setNextBtnEnabled(emblaThumbs.canScrollNext());
        emblaThumbs.scrollTo(emblaThumbs.selectedScrollSnap());
    }, [
        emblaThumbs,
        setSelectedIndex
    ]);
    (0,react.useEffect)(function() {
        if (!emblaThumbs) return;
        onSelect();
        emblaThumbs.on("select", onSelect);
    }, [
        emblaThumbs,
        onSelect
    ]);
    var ref6 = (0,react.useState)(false), openInfoPhoto = ref6[0], setOpenInfoPhoto = ref6[1];
    var closeHandler = function() {
        return [
            onClose(null),
            setOpenInfoPhoto(false)
        ];
    };
    (0,useKey/* default */.Z)("Escape", closeHandler);
    (0,useKey/* default */.Z)("ArrowLeft", function() {
        return emblaThumbs.scrollPrev();
    }, {}, [
        emblaThumbs
    ]);
    (0,useKey/* default */.Z)("ArrowRight", function() {
        return emblaThumbs.scrollNext();
    }, {}, [
        emblaThumbs
    ]);
    (0,useLockBodyScroll/* default */.Z)(isOpen);
    var ref7, ref8;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hover, {
                open: isOpen,
                onClick: closeHandler
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,classcat/* default */.Z)([
                    (gallerymodal_module_default()).modal,
                    (0,_define_property/* default */.Z)({}, (gallerymodal_module_default()).open, isOpen)
                ]),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (gallerymodal_module_default()).gallery,
                        children: [
                            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,classcat/* default */.Z)([
                                    (gallerymodal_module_default()).embla,
                                    (gallerymodal_module_default()).mainEmbla,
                                    (0,_define_property/* default */.Z)({}, (gallerymodal_module_default()).short, !isSidebar), 
                                ]),
                                children: [
                                    maxi.map(function(i, index) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                            className: (0,classcat/* default */.Z)([
                                                (gallerymodal_module_default()).emblaSlideInner,
                                                (gallerymodal_module_default()).emblaSlideMain,
                                                (0,_define_property/* default */.Z)({}, (gallerymodal_module_default()).hidden, index !== selectedIndex), 
                                            ]),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                className: (gallerymodal_module_default()).emblaSlideImg,
                                                src: i.url.src,
                                                srcSet: i.url.srcset,
                                                alt: (ref7 = i === null || i === void 0 ? void 0 : i.description) !== null && ref7 !== void 0 ? ref7 : "",
                                                loading: "lazy",
                                                title: (ref8 = i === null || i === void 0 ? void 0 : i.description) !== null && ref8 !== void 0 ? ref8 : ""
                                            })
                                        });
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrows/* PrevThumbArrow */.Ci, {
                                        onClick: function() {
                                            scrollPrev();
                                            if (onPrevArrow) {
                                                onPrevArrow();
                                            }
                                            if (onArrowPrev) {
                                                onArrowPrev();
                                            }
                                        },
                                        enabled: prevBtnEnabled
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrows/* NextThumbArrow */.s6, {
                                        onClick: function() {
                                            scrollNext();
                                            if (onNextArrow) {
                                                onNextArrow();
                                            }
                                            if (onArrowNext) {
                                                onArrowNext();
                                            }
                                        },
                                        enabled: nextBtnEnabled
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (gallerymodal_module_default()).footer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (gallerymodal_module_default()).head,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: (gallerymodal_module_default()).count,
                                                children: [
                                                    selectedIndex + 1,
                                                    " из ",
                                                    mini === null || mini === void 0 ? void 0 : mini.length
                                                ]
                                            }),
                                            maxi === null || maxi === void 0 ? void 0 : maxi.map(function(i, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (0,classcat/* default */.Z)([
                                                        (0,_define_property/* default */.Z)({}, (gallerymodal_module_default()).hidden, index !== selectedIndex)
                                                    ]),
                                                    children: i.description
                                                }, index);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,classcat/* default */.Z)([
                                            (gallerymodal_module_default()).embla,
                                            (gallerymodal_module_default()).emblaThumb
                                        ]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (gallerymodal_module_default()).emblaViewport,
                                            ref: thumbViewportRef,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (0,classcat/* default */.Z)([
                                                    (gallerymodal_module_default()).emblaContainer,
                                                    (gallerymodal_module_default()).emblaContainerThumb, 
                                                ]),
                                                children: mini === null || mini === void 0 ? void 0 : mini.map(function(i, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumb, {
                                                        onClick: function() {
                                                            onThumbClick(index);
                                                            if (onClickImg) {
                                                                onClickImg();
                                                            }
                                                            if (onImgClick) {
                                                                onImgClick();
                                                            }
                                                        },
                                                        selected: index === selectedIndex,
                                                        imgSrc: i.url,
                                                        description: i.description
                                                    }, index);
                                                })
                                            })
                                        })
                                    }),
                                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (gallerymodal_module_default()).infoPhoto,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (gallerymodal_module_default()).infoPhotoHead,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    className: (gallerymodal_module_default()).infoPhotoButton,
                                                    onClick: function() {
                                                        return setOpenInfoPhoto(!openInfoPhoto);
                                                    },
                                                    children: [
                                                        "Информация о фотографиях",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: openInfoPhoto ? (gallerymodal_module_default()).infoPhotoInsideReverse : (gallerymodal_module_default()).infoPhotoInside
                                                        })
                                                    ]
                                                })
                                            }),
                                            openInfoPhoto && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (gallerymodal_module_default()).infoPhotoOpen,
                                                children: "Обратите внимание, что представленные фотографии соответствуют категориям кают, но являются базовыми. В зависимости от номера каюты интерьер может немного отличаться."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    reviews && reviews.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (gallerymodal_module_default()).reviews,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (gallerymodal_module_default()).head,
                                children: [
                                    name && type && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                        view: type,
                                        icon: type,
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge/* Badge */.C, {
                                        view: "rewies",
                                        icon: "reviews",
                                        children: [
                                            String(reviews.length),
                                            " отзывов"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (gallerymodal_module_default()).scrollBar,
                                children: [
                                    reviews.slice(0, show).map(function(i, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Comment/* Comment */.s, {
                                            isMobile: isMobile,
                                            userPick: i.user_img && "".concat("https://kruiz.online", "/").concat(i.user_img),
                                            name: i.username,
                                            date: dayjs_min_default()(i.r_date).format("DD MMMM YYYY"),
                                            className: (gallerymodal_module_default()).commentWrapper,
                                            isModal: true,
                                            children: i.review
                                        }, index);
                                    }),
                                    isCanShowMore && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (gallerymodal_module_default()).showMore,
                                        onClick: function() {
                                            onShowMore();
                                            if (onClickMore) {
                                                onClickMore();
                                            }
                                            if (onMoreClick) {
                                                onMoreClick();
                                            }
                                        },
                                        children: "Показать еще"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (gallerymodal_module_default()).close,
                        onClick: function() {
                            onClose(null);
                            if (onCloseAction) {
                                onCloseAction();
                                setOpenInfoPhoto(false);
                            }
                            if (onActionClose) {
                                onActionClose();
                                setOpenInfoPhoto(false);
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (gallerymodal_module_default()).iconHolder,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                    name: "common/close-white",
                                    width: 16,
                                    height: 16,
                                    alt: "Закрыть"
                                }),
                                title: "Закрыть"
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/GalleryModal/index.js


// EXTERNAL MODULE: ./lib/YaAndGaHelper.js + 2 modules
var YaAndGaHelper = __webpack_require__(38214);
// EXTERNAL MODULE: ./utils/reworkUrl.js
var reworkUrl = __webpack_require__(31181);
;// CONCATENATED MODULE: ./components/CruisePageComponents/MainGallery/MainGallery.jsx











var prepareImages = function(maxi, mini) {
    var needCrop = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (needCrop) return mini.map(function(i) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, i), {
            url: i.url
        });
    });
    return maxi.map(function(i) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, i), {
            url: i.url
        });
    });
};
var MainGallery = function(param) {
    var maxi = param.maxi, mini = param.mini, isMobile = param.isMobile, reviews = param.reviews, category = param.category, title = param.title, shipPage = param.shipPage, isSea = param.isSea, onCloseAction = param.onCloseAction, onActionClose = param.onActionClose, onPrevArrow = param.onPrevArrow, onNextArrow = param.onNextArrow, onClickImg = param.onClickImg, onImgClick = param.onImgClick, onClickMore = param.onClickMore, onMoreClick = param.onMoreClick, onArrowNext = param.onArrowNext, onArrowPrev = param.onArrowPrev;
    var ref = (0,react.useState)(null), isGalleryOpen = ref[0], setIsGalleryOpen = ref[1];
    var maxiImages = prepareImages(maxi, mini, false);
    var miniImages = prepareImages(maxi, mini, true);
    var openGallery = function(e, index) {
        e.preventDefault();
        setIsGalleryOpen(index);
    };
    // const getUrl = (url, _isSea) => _isSea ? `sea.${process.env.NEXT_PUBLIC_BASE_URL.}${url}` : `${process.env.NEXT_PUBLIC_BASE_URL}${url}`;
    // sea.https://kruiz.tech/assets/img/liners/liners/bergth_800x500/165933246662e76772b0aa9.jpg
    return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {
        data: maxiImages
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryModal, {
                isMobile: isMobile,
                title: title,
                category: category,
                maxi: maxiImages,
                mini: miniImages,
                reviews: reviews,
                activeImg: isGalleryOpen,
                onClose: setIsGalleryOpen,
                onCloseAction: onCloseAction,
                onActionClose: onActionClose,
                onPrevArrow: onPrevArrow,
                onNextArrow: onNextArrow,
                onClickImg: onClickImg,
                onImgClick: onImgClick,
                onClickMore: onClickMore,
                onMoreClick: onMoreClick,
                onArrowNext: onArrowNext,
                onArrowPrev: onArrowPrev
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: !shipPage ? (maingallery_module_default()).imagesBlock : (maingallery_module_default()).imagesBlockShip,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: (0,reworkUrl/* ReworkUrl */.$)(maxiImages[0].url),
                        onClick: function(e) {
                            openGallery(e, 0);
                            if (!shipPage && !isSea) {
                                (0,YaAndGaHelper/* YaAndGaCruisePage */.uX)("click_modal_photo");
                            }
                            if (shipPage && !isSea) {
                                (0,YaAndGaHelper/* YaAndGaShipPage */.tj)("click_view_all_photos");
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                className: (maingallery_module_default()).headerImage,
                                src: maxiImages[0].url.src,
                                srcSet: maxiImages[0].url.srcset,
                                alt: maxiImages[0].description,
                                loading: "lazy",
                                title: maxiImages[0].description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenLigtBox_OpenLightBox, {
                                onClick: function(e) {
                                    return openGallery(e, 0);
                                }
                            })
                        ]
                    }),
                    !shipPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (maingallery_module_default()).gridImages,
                        children: maxiImages.slice(1, 5).map(function(i, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: (0,reworkUrl/* ReworkUrl */.$)(i.url),
                                onClick: function(e) {
                                    return openGallery(e, index + 1);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    className: (maingallery_module_default()).gridImage,
                                    src: i.url.src,
                                    srcSet: i.url.srcset,
                                    alt: i.description,
                                    title: i.description,
                                    loading: "lazy"
                                }, i.url)
                            }, i.url);
                        })
                    }),
                    shipPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (maingallery_module_default()).gridImagesShips,
                        children: maxiImages.slice(1, 4).map(function(i, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: (0,reworkUrl/* ReworkUrl */.$)(i.url),
                                onClick: function(e) {
                                    return openGallery(e, index + 1);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    className: (maingallery_module_default()).gridImage,
                                    src: i.url.src,
                                    srcSet: i.url.srcset,
                                    alt: i.description,
                                    title: i.description,
                                    loading: "lazy"
                                }, i.url)
                            }, i.url);
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/CruisePageComponents/MainGallery/index.js



/***/ }),

/***/ 96705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* reexport */ PricePanel; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/mobx-react-lite/es/index.js + 13 modules
var es = __webpack_require__(46670);
// EXTERNAL MODULE: ./components/CruisePageComponents/PricePanel/pricepanel.module.sass
var pricepanel_module = __webpack_require__(25246);
var pricepanel_module_default = /*#__PURE__*/__webpack_require__.n(pricepanel_module);
// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
// EXTERNAL MODULE: ./utils/formatter.js
var formatter = __webpack_require__(88091);
// EXTERNAL MODULE: ./components/Button/index.js + 1 modules
var Button = __webpack_require__(11866);
// EXTERNAL MODULE: ./providers/RootStoreProvider.jsx + 49 modules
var RootStoreProvider = __webpack_require__(8710);
// EXTERNAL MODULE: ./utils/isClient.js
var isClient = __webpack_require__(69594);
// EXTERNAL MODULE: ./utils/declOfNum.js
var declOfNum = __webpack_require__(5547);
// EXTERNAL MODULE: ./components/seaRequestMini/SeaRequestMini.jsx
var SeaRequestMini = __webpack_require__(41170);
;// CONCATENATED MODULE: ./components/seaRequestMini/index.js


// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
// EXTERNAL MODULE: ./lib/YaAndGaHelper.js + 2 modules
var YaAndGaHelper = __webpack_require__(38214);
// EXTERNAL MODULE: ./components/TooltipDiscount/index.js + 1 modules
var TooltipDiscount = __webpack_require__(31446);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
// EXTERNAL MODULE: ./components/Informer/index.js + 1 modules
var Informer = __webpack_require__(96652);
// EXTERNAL MODULE: ./lib/yandexDataLayer.js
var yandexDataLayer = __webpack_require__(12406);
// EXTERNAL MODULE: ./lib/sendVKPixelEvent.js
var sendVKPixelEvent = __webpack_require__(13866);
;// CONCATENATED MODULE: ./components/CruisePageComponents/PricePanel/PricePanel.jsx




















var PricePanel = (0,es/* observer */.Pi)(function(param) {
    var cruizDetail = param.cruizDetail, price = param.price, onChoose = param.onChoose, priceDiscounted = param.priceDiscounted, elRef = param.elRef, data = param.data, cashback = param.cashback, isShips = param.isShips, isSea = param.isSea, titleShip = param.titleShip, cruiseDateS = param.cruiseDateS, cruiseDateE = param.cruiseDateE, cruiseDays = param.cruiseDays, isSpecialOffer = param.isSpecialOffer, users = param.users, ownerId = param.ownerId, specialOfferValue = param.specialOfferValue, isDisabledOnlinePay = param.isDisabledOnlinePay, isMobile = param.isMobile, blackFriday = param.blackFriday, shipId = param.shipId;
    var store = (0,RootStoreProvider/* useFavorites */.rc)();
    var cruiseStore = (0,RootStoreProvider/* useCruizStore */.EC)();
    var seaStore = (0,RootStoreProvider/* useSeaCruiseStore */.J)();
    var discountStore = (0,RootStoreProvider/* useDiscountStore */.wm)();
    var isEarlyBooking = priceDiscounted !== 0;
    var isFavorite = store.checkById(data === null || data === void 0 ? void 0 : data.id);
    var isZero = price - priceDiscounted === 0;
    var isFunSun = function() {
        return cruiseStore.isFunSun() || ownerId === 100025;
    };
    var discounts = discountStore.discounts, rb = discountStore.rb, isDiscounts = discountStore.isDiscounts;
    var toggleFavorite = function() {
        store.toggle(data);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (pricepanel_module_default()).price,
        ref: elRef,
        children: [
            price !== "0" && price !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (pricepanel_module_default()).priceWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (pricepanel_module_default()).priceOld,
                        children: [
                            price && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    variant: "heading-4",
                                    children: price > 200 && "от ".concat((0,formatter/* formatter */.z)(isEarlyBooking ? priceDiscounted : price), " ₽\n                    ").concat(isFunSun() ? "" : "/ чел.")
                                })
                            }),
                            price !== priceDiscounted && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (pricepanel_module_default()).priceOldContent,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: (pricepanel_module_default()).priceOldRed,
                                    children: [
                                        "от ",
                                        (0,formatter/* formatter */.z)(isEarlyBooking && price),
                                        " ₽"
                                    ]
                                })
                            })
                        ]
                    }),
                    isSpecialOffer && (rb === null || rb === void 0 ? void 0 : rb.days_before_rise) || shipId === 209 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (pricepanel_module_default()).specialOffer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (pricepanel_module_default()).specialOfferDescription,
                                children: blackFriday ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    variant: "heading-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (pricepanel_module_default()).textWrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            children: "Цена указана с учетом примененной скидки."
                                        })
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                name: "promo/present",
                                                width: 18,
                                                height: 19
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                            children: [
                                                "Действует спецпредложение",
                                                " ",
                                                specialOfferValue !== null && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        "-",
                                                        specialOfferValue,
                                                        "%"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            !blackFriday && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    variant: "text-3",
                                    size: "sm",
                                    children: "Цена указана со скидкой"
                                })
                            })
                        ]
                    }),
                    (rb === null || rb === void 0 ? void 0 : rb.days_before_rise) && price !== priceDiscounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        variant: "heading-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (pricepanel_module_default()).textWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                children: "Указана цена со скидкой раннего бронирования."
                            })
                        })
                    })
                ]
            }) : "",
            isEarlyBooking && !isZero && !blackFriday && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (pricepanel_module_default()).priceGroup,
                children: [
                    (rb === null || rb === void 0 ? void 0 : rb.days_before_rise) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        children: "Дороже на"
                    }),
                    (rb === null || rb === void 0 ? void 0 : rb.days_before_rise) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                        variant: "text-4",
                        color: "red2",
                        children: [
                            (0,formatter/* formatter */.z)(parseInt(price, 10) - parseInt(priceDiscounted, 10)),
                            " ",
                            "₽",
                            "    "
                        ]
                    }),
                    "      ",
                    (rb === null || rb === void 0 ? void 0 : rb.days_before_rise) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        children: " через "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                        variant: "text-4",
                        children: [
                            (rb === null || rb === void 0 ? void 0 : rb.days_before_rise) && (rb === null || rb === void 0 ? void 0 : rb.days_before_rise),
                            " ",
                            (rb === null || rb === void 0 ? void 0 : rb.days_before_rise) && (0,declOfNum/* declOfNum */.A)(rb === null || rb === void 0 ? void 0 : rb.days_before_rise, [
                                "день",
                                "дня",
                                "дней"
                            ])
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (pricepanel_module_default()).pickWrapper,
                children: [
                    !isSea && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        size: "semi-lg",
                        fullWidth: true,
                        background: "primary",
                        onClick: function() {
                            onChoose();
                            if (!isShips) {
                                (0,YaAndGaHelper/* YaAndGaCruisePage */.uX)("click_choose_of_cabin_cruise_page");
                            }
                        },
                        children: isShips ? "Выбрать круиз" : "Выбрать каюту"
                    }),
                    seaStore.available !== 0 && seaStore.outputTree.length !== 0 || seaStore.loadingCabin ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        size: "semi-lg",
                        fullWidth: true,
                        background: "primary",
                        onClick: onChoose,
                        children: isShips ? "Выбрать круиз" : "Выбрать каюту"
                    }) : isSea && seaStore.isMSC && /*#__PURE__*/ (0,jsx_runtime.jsx)(SeaRequestMini/* SeaRequestMini */.x, {
                        title: titleShip,
                        onChoose: onChoose,
                        isShips: isShips,
                        cruiseDateS: cruiseDateS,
                        cruiseDateE: cruiseDateE,
                        cruiseDays: cruiseDays,
                        users: users,
                        isMobile: isMobile
                    })
                ]
            }),
            !isShips && isClient/* isClient */.C && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: (pricepanel_module_default()).heartBtn,
                onClick: function() {
                    toggleFavorite();
                    if (!isFavorite) {
                        (0,YaAndGaHelper/* YaAndGaCruisePage */.uX)("click_add_to_basket_cruise_page");
                        (0,yandexDataLayer/* yandexDataLayer */.qu)("add", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cruizDetail), {
                            quantity: 1
                        }));
                        (0,sendVKPixelEvent/* sendVKPixelEvent */.c)("AddToCart", {
                            product_id: cruizDetail.id,
                            value: cruizDetail.price
                        });
                    } else {
                        (0,yandexDataLayer/* yandexDataLayer */.qu)("remove", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cruizDetail), {
                            quantity: 1
                        }));
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: !isFavorite ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                name: "common/cart",
                                width: 20,
                                height: 20
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                name: "common/cart-active",
                                width: 20,
                                height: 20
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: !isFavorite ? "Добавить в корзину" : "В корзине"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (pricepanel_module_default()).pickPriceBlock,
                children: [
                    isDisabledOnlinePay && /*#__PURE__*/ (0,jsx_runtime.jsx)(Informer/* Informer */.X, {}),
                    !isSea && isDiscounts && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            cashback === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (pricepanel_module_default()).pickPrice,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (pricepanel_module_default()).cashbackAll,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                name: "promo/cashback",
                                                width: 24,
                                                height: 24
                                            }),
                                            rightGap: 8,
                                            title: "Иконка кэшбека"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (pricepanel_module_default()).cashback,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (pricepanel_module_default()).cashback,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "Кэшбэк 20% при оплате картой МИР"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (pricepanel_module_default()).pickPrice,
                                children: discounts.map(function(i, ind) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (pricepanel_module_default()).priceTextSalePercent,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (pricepanel_module_default()).priceTextSale,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                            variant: "text-3",
                                                            colorText: "white",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    "-",
                                                                    Object.keys(i).join(),
                                                                    "% "
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (pricepanel_module_default()).priseTextOut,
                                                        children: price !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                                            variant: "text-4",
                                                            children: [
                                                                "от",
                                                                " ",
                                                                Object.values(i)[0][0].price ? (0,formatter/* formatter */.z)(Object.values(i)[0][0].price) : (0,formatter/* formatter */.z)(Math.floor(parseInt(price, 10) - parseInt(price, 10) * (Object.keys(i) / 100))),
                                                                " ",
                                                                "₽",
                                                                isFunSun() ? "" : "/чел."
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: ind + 1 === discounts.length ? (pricepanel_module_default()).panelDiscountForTextTwo : (pricepanel_module_default()).panelDiscountForText,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                    children: Object.values(i)[0].map(function(item, id) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (pricepanel_module_default()).tooltipBlock,
                                                            children: id === 0 ? item.description !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipDiscount/* TooltipDiscount */.q, {
                                                                trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    children: [
                                                                        item.alias.replace("Скидка", ""),
                                                                        Object.values(i)[0].length === 1 ? "" : "; "
                                                                    ]
                                                                }),
                                                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: item.description
                                                                })
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: item.alias.replace("Скидка", "")
                                                            }) : item.description !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipDiscount/* TooltipDiscount */.q, {
                                                                trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    children: [
                                                                        item.alias.replace("Скидка", ""),
                                                                        id + 1 === Object.values(i)[0].length ? "" : "; "
                                                                    ]
                                                                }),
                                                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: item.description
                                                                })
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: item.alias.replace("Скидка", "")
                                                            })
                                                        });
                                                    })
                                                })
                                            })
                                        ]
                                    }, ind);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (pricepanel_module_default()).sumSales,
                                children: !isSea && isDiscounts && "Скидки не суммируются"
                            })
                        ]
                    })
                ]
            })
        ]
    });
});

;// CONCATENATED MODULE: ./components/CruisePageComponents/PricePanel/index.js



/***/ }),

/***/ 15944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ Features; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Features/features.module.sass
var features_module = __webpack_require__(37661);
var features_module_default = /*#__PURE__*/__webpack_require__.n(features_module);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
// EXTERNAL MODULE: ./components/Button/index.js + 1 modules
var Button = __webpack_require__(11866);
;// CONCATENATED MODULE: ./components/Features/Features.jsx










/**
 * Список для услуг
 */ var Features = function(_param) {
    var features = _param.features, props = (0,_object_without_properties/* default */.Z)(_param, [
        "features"
    ]);
    var ref = (0,react.useState)(8), clipp = ref[0], setClipp = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: (features_module_default()).features
            }, props), {
                children: features && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (features_module_default()).features,
                    children: features.length <= 8 ? features.map(function(i, id) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: (features_module_default()).featuresList,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                    rightGap: 8,
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                        name: "services/".concat(i.icon),
                                        width: 24,
                                        height: 24
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (features_module_default()).featuresLabel,
                                    children: i.facility_name
                                })
                            ]
                        }, id);
                    }) : features.slice(0, clipp).map(function(i, id) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: (features_module_default()).featuresList,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                    rightGap: 8,
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                        name: "services/".concat(i.icon),
                                        width: 24,
                                        height: 24
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (features_module_default()).featuresLabel,
                                    children: i.facility_name
                                })
                            ]
                        }, id);
                    })
                })
            })),
            features && features.length > 8 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (features_module_default()).showMore,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    view: "white",
                    onClick: function() {
                        return [
                            setClipp(clipp === 8 ? features.length : 8),
                            window.ym(35441960, "reachGoal", "cruise_page_expanded_full_list_of_onboard_services_section_description"), 
                        ];
                    },
                    children: clipp === 8 ? "Показать все услуги" : "Скрыть"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Features/index.js



/***/ }),

/***/ 96652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* reexport */ Informer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Informer/informer.module.sass
var informer_module = __webpack_require__(82639);
var informer_module_default = /*#__PURE__*/__webpack_require__.n(informer_module);
// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
;// CONCATENATED MODULE: ./components/Informer/Informer.jsx






var Informer = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (informer_module_default()).informer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (informer_module_default()).informerBlock,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                        name: "promo/informer",
                        width: 24,
                        height: 24
                    }),
                    rightGap: 8,
                    title: "Иконка телефона"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        variant: "medicalInfo",
                        children: "Оплата после подтверждения менеджером"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/Informer/index.js



/***/ }),

/***/ 72581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ ModalReload; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/Modal/index.js
var Modal = __webpack_require__(178);
// EXTERNAL MODULE: ./components/ModalReload/modalReload.module.sass
var modalReload_module = __webpack_require__(50585);
var modalReload_module_default = /*#__PURE__*/__webpack_require__.n(modalReload_module);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
// EXTERNAL MODULE: ./components/Button/index.js + 1 modules
var Button = __webpack_require__(11866);
// EXTERNAL MODULE: ./providers/RootStoreProvider.jsx + 49 modules
var RootStoreProvider = __webpack_require__(8710);
;// CONCATENATED MODULE: ./components/ModalReload/ModalReload.jsx








var ModalReload = function() {
    var store = (0,RootStoreProvider/* useAuthStore */.tN)();
    var isManager = store.isManager;
    var router = (0,next_router.useRouter)();
    // Состояние для отслеживания видимости модального окна
    var ref = (0,react.useState)(false), isModalOpen = ref[0], setIsModalOpen = ref[1];
    // Состояние для хранения момента времени открытия страницы
    var ref1 = (0,react.useState)(new Date()), pageOpenTime = ref1[0];
    (0,react.useEffect)(function() {
        // Функция для проверки, прошло ли 15 минут
        var checkTime = function() {
            if (new Date() - pageOpenTime > 15 * 60 * 1000) {
                setIsModalOpen(true);
            }
        };
        // Запуск интервала
        var interval = setInterval(checkTime, 60 * 1000); // Проверяем каждую минуту
        // Очистка интервала
        return function() {
            return clearInterval(interval);
        };
    }, [
        pageOpenTime
    ]);
    // Функция для перезагрузки страницы
    var handleReload = function() {
        router.reload();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isManager && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
            isOpen: isModalOpen,
            onOpen: setIsModalOpen,
            title: "Данные устарели",
            size: "dialog",
            centerHeader: true,
            hideCross: true,
            noClickAway: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (modalReload_module_default()).modalReload,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                        name: "common/reload",
                        width: 86,
                        height: 86
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Наличие мест и цены могли измениться."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        view: "buttonModalData",
                        size: "lg",
                        onClick: handleReload,
                        children: "Перезагрузить страницу"
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/ModalReload/index.js



/***/ }),

/***/ 31446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* reexport */ TooltipDiscount; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@floating-ui/react-dom-interactions/dist/floating-ui.react-dom-interactions.esm.js
var floating_ui_react_dom_interactions_esm = __webpack_require__(35082);
// EXTERNAL MODULE: ./node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs + 2 modules
var floating_ui_dom = __webpack_require__(24750);
// EXTERNAL MODULE: ./node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.esm.js
var floating_ui_react_dom_esm = __webpack_require__(58463);
// EXTERNAL MODULE: ./components/TooltipDiscount/tooltipDiscount.module.sass
var tooltipDiscount_module = __webpack_require__(19394);
var tooltipDiscount_module_default = /*#__PURE__*/__webpack_require__.n(tooltipDiscount_module);
;// CONCATENATED MODULE: ./components/TooltipDiscount/TooltipDiscount.jsx









var TooltipDiscount = function(param) {
    var trigger = param.trigger, content = param.content, placement = param.placement, view = param.view;
    var ref, ref1;
    var ref2 = (0,react.useState)(false), open = ref2[0], setOpen = ref2[1];
    var arrowRef = (0,react.useRef)(null);
    var isWhite = view === "white";
    var ref3 = (0,floating_ui_react_dom_interactions_esm/* useFloating */.YF)({
        open: open,
        onOpenChange: setOpen,
        placement: placement !== null && placement !== void 0 ? placement : "bottom",
        middleware: [
            (0,floating_ui_dom/* offset */.cv)(8),
            (0,floating_ui_dom/* shift */.uY)({
                padding: 16
            }),
            (0,floating_ui_react_dom_esm/* arrow */.x7)({
                element: arrowRef
            }), 
        ]
    }), x = ref3.x, y = ref3.y, reference = ref3.reference, floating = ref3.floating, strategy = ref3.strategy, context = ref3.context, middlewareData = ref3.middlewareData;
    var hover = (0,floating_ui_react_dom_interactions_esm/* useHover */.XI)(context, {
        delay: {
            open: 75,
            close: 150
        },
        mouseOnly: true,
        restMs: 150
    });
    var ref4 = (0,floating_ui_react_dom_interactions_esm/* useInteractions */.NI)([
        (0,floating_ui_react_dom_interactions_esm/* useDismiss */.bQ)(context),
        hover, 
    ]), getReferenceProps = ref4.getReferenceProps, getFloatingProps = ref4.getFloatingProps;
    var staticSide = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right"
    };
    var handleShowDropDown = function() {
        setOpen(true);
    };
    var handleCloseDropDown = function() {
        setOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (tooltipDiscount_module_default()).toolWrapper,
            children: [
                /*#__PURE__*/ (0,react.cloneElement)(trigger, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getReferenceProps({
                    ref: reference
                })), {
                    onClick: handleShowDropDown
                })),
                open && /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: (tooltipDiscount_module_default()).toolBackdrop,
                    onClick: handleCloseDropDown,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        className: isWhite ? (tooltipDiscount_module_default()).toolInsideWhite : (tooltipDiscount_module_default()).toolInside
                    }, getFloatingProps({
                        ref: floating,
                        style: {
                            position: strategy,
                            left: x !== null && x !== void 0 ? x : 0,
                            top: y !== null && y !== void 0 ? y : 0
                        }
                    })), {
                        children: [
                            content,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: isWhite ? (tooltipDiscount_module_default()).arrowWhite : placement === "right" ? (tooltipDiscount_module_default()).arrowRight : (tooltipDiscount_module_default()).arrow,
                                ref: arrowRef,
                                style: (0,_define_property/* default */.Z)({
                                    left: ((ref = middlewareData.arrow) === null || ref === void 0 ? void 0 : ref.x) != null ? "".concat(middlewareData.arrow.x, "px") : "",
                                    top: ((ref1 = middlewareData.arrow) === null || ref1 === void 0 ? void 0 : ref1.y) != null ? "".concat(middlewareData.arrow.y, "px") : ""
                                }, staticSide, "-4px")
                            })
                        ]
                    }))
                }), document.body)
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/TooltipDiscount/index.js



/***/ }),

/***/ 41170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ SeaRequestMini; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var mobx_react_lite__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46670);
/* harmony import */ var react_input_mask__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76627);
/* harmony import */ var react_input_mask__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_input_mask__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(82580);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16310);
/* harmony import */ var _providers_RootStoreProvider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8710);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11866);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21794);
/* harmony import */ var _utils_unFormatterPhone__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(23104);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82372);
/* harmony import */ var _seaRequestMini_module_sass__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(39429);
/* harmony import */ var _seaRequestMini_module_sass__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_seaRequestMini_module_sass__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _SuccessForm__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90761);
/* harmony import */ var _utils_formatter__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88091);








// import d from 'dayjs';

// import { Modal } from '../Modal';







var fullSchema = yup__WEBPACK_IMPORTED_MODULE_5__/* .object */ .Ry().shape({
    name: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().min(2, "Имя должно содержать больше 2 символов").max(25, "Имя не должно содержать больше 25 символов").matches(/^[а-яА-ЯёЁa-zA-Z\s]+$/, "Введите корректное Имя и Фамилию").trim().required("Обязательное поле"),
    phone: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().trim().min(11, "Введите номер телефона").max(11, "").required("Обязательное поле")
});
var phoneSchema = yup__WEBPACK_IMPORTED_MODULE_5__/* .object */ .Ry().shape({
    phone: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().trim().min(11, "Введите номер телефона").max(11, "").required("Обязательное поле")
});
var SeaRequestMini = (0,mobx_react_lite__WEBPACK_IMPORTED_MODULE_3__/* .observer */ .Pi)(function(param) {
    var isShips = param.isShips, users = param.users, minPrice = param.minPrice, onlyPhone = param.onlyPhone, isMobile = param.isMobile;
    var ref, ref1, ref2, ref3, ref4;
    var seaStore = (0,_providers_RootStoreProvider__WEBPACK_IMPORTED_MODULE_6__/* .useSeaCruiseStore */ .J)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: (_seaRequestMini_module_sass__WEBPACK_IMPORTED_MODULE_11___default().main),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_12__/* .Formik */ .J9, {
                validationSchema: onlyPhone ? phoneSchema : fullSchema,
                initialValues: {
                    phone: "",
                    name: (users === null || users === void 0 ? void 0 : (ref = users.user) === null || ref === void 0 ? void 0 : ref.name) ? "".concat(users === null || users === void 0 ? void 0 : users.user.name, " ").concat(users === null || users === void 0 ? void 0 : users.user.patronymic, " ").concat(users === null || users === void 0 ? void 0 : users.user.surname) : "Неавторизованный",
                    success: false,
                    cruis_id: seaStore.id,
                    category_id: seaStore === null || seaStore === void 0 ? void 0 : (ref1 = seaStore.activeCabin) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.category_info) === null || ref2 === void 0 ? void 0 : ref2.id,
                    category_name: seaStore === null || seaStore === void 0 ? void 0 : (ref3 = seaStore.activeCabin) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.category_info) === null || ref4 === void 0 ? void 0 : ref4.category
                },
                onSubmit: function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
                        var phone, name, cruis_id, category_id, category_name, setFieldValue;
                        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    phone = param.phone, name = param.name, cruis_id = param.cruis_id, category_id = param.category_id, category_name = param.category_name, setFieldValue = param1.setFieldValue;
                                    _ctx.prev = 1;
                                    _ctx.next = 4;
                                    return seaStore.getRequestStatus(name, phone, cruis_id, category_id, category_name);
                                case 4:
                                    _ctx.next = 9;
                                    break;
                                case 6:
                                    _ctx.prev = 6;
                                    _ctx.t0 = _ctx["catch"](1);
                                    // eslint-disable-next-line no-console
                                    console.log("error", _ctx.t0);
                                case 9:
                                    _ctx.prev = 9;
                                    setFieldValue("success", true);
                                    return _ctx.finish(9);
                                case 12:
                                    window.ym(35441960, "reachGoal", "price_request");
                                case 13:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee, null, [
                            [
                                1,
                                6,
                                9,
                                12
                            ]
                        ]);
                    }));
                    return function(_, _1) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                children: function(param) {
                    var values = param.values, setFieldValue = param.setFieldValue, errors = param.errors, touched = param.touched, isSubmitting = param.isSubmitting;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: !values.success ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_12__/* .Form */ .l0, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: (_seaRequestMini_module_sass__WEBPACK_IMPORTED_MODULE_11___default().block),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: (_seaRequestMini_module_sass__WEBPACK_IMPORTED_MODULE_11___default().blockPrice),
                                            children: minPrice ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Text__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                                                variant: "price",
                                                children: [
                                                    "от ",
                                                    (0,_utils_formatter__WEBPACK_IMPORTED_MODULE_14__/* .formatter */ .z)(minPrice),
                                                    " ₽ / чел."
                                                ]
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                                                variant: "price",
                                                children: "Цена по запросу"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: (_seaRequestMini_module_sass__WEBPACK_IMPORTED_MODULE_11___default().blockMissing),
                                            children: minPrice ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                                                variant: "missing",
                                                children: "Наличие кают по запросу"
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                                                variant: "missing",
                                                children: "Свободные каюты отсутствуют"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: (_seaRequestMini_module_sass__WEBPACK_IMPORTED_MODULE_11___default().formik),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: (_seaRequestMini_module_sass__WEBPACK_IMPORTED_MODULE_11___default().form),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: (_seaRequestMini_module_sass__WEBPACK_IMPORTED_MODULE_11___default().formikPhone),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_8__/* .Input */ .I, {
                                                    noBoldLabel: true,
                                                    control: (react_input_mask__WEBPACK_IMPORTED_MODULE_4___default()),
                                                    values: values.phone,
                                                    label: "Номер телефона",
                                                    id: "phone",
                                                    name: "phone",
                                                    mask: "+7 999 999-99-99",
                                                    onChange: function(e) {
                                                        setFieldValue("phone", (0,_utils_unFormatterPhone__WEBPACK_IMPORTED_MODULE_15__/* .unFormatterPhone */ .Z)(e.target.value));
                                                    },
                                                    error: touched.phone && errors.phone
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: (_seaRequestMini_module_sass__WEBPACK_IMPORTED_MODULE_11___default().formikButton),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .z, {
                                                size: "lg",
                                                fullWidth: true,
                                                background: "primary",
                                                type: "submit",
                                                disabled: isSubmitting,
                                                onClick: function() {
                                                    return window.ym(35441960, "reachGoal", "price_request");
                                                },
                                                children: isShips ? "Выбрать круиз" : "Оставить заявку"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: (_seaRequestMini_module_sass__WEBPACK_IMPORTED_MODULE_11___default().mainPage),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                                                variant: "linkTextPopap",
                                                children: "или посмотрите все круизы"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_9__/* .Anchor */ .e, {
                                                className: (_seaRequestMini_module_sass__WEBPACK_IMPORTED_MODULE_11___default().mainPageLink),
                                                href: "/sea",
                                                children: "на главной странице"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (_seaRequestMini_module_sass__WEBPACK_IMPORTED_MODULE_11___default().success),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SuccessForm__WEBPACK_IMPORTED_MODULE_10__/* .SuccessForm */ .r, {
                                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    children: "Ваша заявка успешно отправлена!"
                                }),
                                text: "Мы свяжемся с вами, если появятся свободные места или предложения схожих круизов."
                            })
                        })
                    });
                }
            })
        })
    });
});


/***/ }),

/***/ 75685:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"breadCrumbs_wrapper__GujyW","overflowWrapper":"breadCrumbs_overflowWrapper__O0aFR","point":"breadCrumbs_point___AwGt","current":"breadCrumbs_current__uks0O","currentBf":"breadCrumbs_currentBf__aXcqk","active":"breadCrumbs_active__ExqTi","activeBf":"breadCrumbs_activeBf__8B_QV","crumb":"breadCrumbs_crumb__8cnCn","home":"breadCrumbs_home__ahfAn","homeBf":"breadCrumbs_homeBf__oorFp"};

/***/ }),

/***/ 77798:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"embla":"slider_embla__zTuyc","emblaContainer":"slider_emblaContainer__cNcea","emblaSlide":"slider_emblaSlide__t_Jvc","current":"slider_current__mHnRO"};

/***/ }),

/***/ 33903:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imagesBlock":"maingallery_imagesBlock__XVRFt","imagesBlockShip":"maingallery_imagesBlockShip__wwkLc","gridImages":"maingallery_gridImages__RrIxE","gridImagesShips":"maingallery_gridImagesShips__6ppMQ","gridImage":"maingallery_gridImage__0Eq_w","headerImage":"maingallery_headerImage__IK8yL"};

/***/ }),

/***/ 25246:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"price":"pricepanel_price__BKhsG","priceGroup":"pricepanel_priceGroup__Ar5Z_","pickPriceBlock":"pricepanel_pickPriceBlock__VCLPR","tooltipBlock":"pricepanel_tooltipBlock__ye1SB","priceOld":"pricepanel_priceOld__OTBFK","priceOldContent":"pricepanel_priceOldContent__ei2ZK","priceOldRed":"pricepanel_priceOldRed__CG6rc","priceTextSale":"pricepanel_priceTextSale__cyIAP","panelDiscountForText":"pricepanel_panelDiscountForText__VQ4mG","panelDiscountForTextTwo":"pricepanel_panelDiscountForTextTwo___xXwe","priceTextSalePercent":"pricepanel_priceTextSalePercent___Wy53","priseTextOut":"pricepanel_priseTextOut__6BzLO","cashback":"pricepanel_cashback__lyG9x","cashbackAll":"pricepanel_cashbackAll__b5g3Q","pickPrice":"pricepanel_pickPrice__3_Vj2","pickWrapper":"pricepanel_pickWrapper__b0xAb","sumSales":"pricepanel_sumSales__3z_JI","priceWrapper":"pricepanel_priceWrapper__l6If0","textWrapper":"pricepanel_textWrapper__1vji1","heartBtn":"pricepanel_heartBtn__lnvmg","specialOffer":"pricepanel_specialOffer__amrBK","specialOfferDescription":"pricepanel_specialOfferDescription__3ybX5"};

/***/ }),

/***/ 37661:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"features":"features_features__TpZrm","featuresList":"features_featuresList__M2Mz9"};

/***/ }),

/***/ 26819:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlay":"gallerymodal_overlay__2IZ3q","open":"gallerymodal_open__vc_W6","modal":"gallerymodal_modal__hzgIU","gallery":"gallerymodal_gallery__WZEME","embla":"gallerymodal_embla___tMBN","iconHolder":"gallerymodal_iconHolder__4YRLk","infoPhoto":"gallerymodal_infoPhoto__pMNCH","infoPhotoHead":"gallerymodal_infoPhotoHead__DCOCt","infoPhotoButton":"gallerymodal_infoPhotoButton__HwT_d","infoPhotoInside":"gallerymodal_infoPhotoInside__ModJg","infoPhotoInsideReverse":"gallerymodal_infoPhotoInsideReverse__gYqYU","infoPhotoOpen":"gallerymodal_infoPhotoOpen__8uWVS","mainEmbla":"gallerymodal_mainEmbla__ROPjj","short":"gallerymodal_short___DaPV","emblaViewport":"gallerymodal_emblaViewport__ZHMRS","emblaContainer":"gallerymodal_emblaContainer__JeHxL","emblaSlide":"gallerymodal_emblaSlide__vps9k","emblaSlideInner":"gallerymodal_emblaSlideInner__hkaGw","desc":"gallerymodal_desc__StrhQ","emblaSlideMain":"gallerymodal_emblaSlideMain__1tV7G","hidden":"gallerymodal_hidden__m6erP","emblaSlideImg":"gallerymodal_emblaSlideImg__G3xP8","emblaThumb":"gallerymodal_emblaThumb__xCL59","emblaContainerThumb":"gallerymodal_emblaContainerThumb__gm6aU","emblaSlideThumb":"gallerymodal_emblaSlideThumb__oGN5_","emblaSlideInnerThumb":"gallerymodal_emblaSlideInnerThumb__Lx8jS","emblaSlideThumbnail":"gallerymodal_emblaSlideThumbnail__wFVow","isSelected":"gallerymodal_isSelected__H0Dd6","footer":"gallerymodal_footer__enoUL","head":"gallerymodal_head__ZsVKJ","count":"gallerymodal_count__VaZRb","reviews":"gallerymodal_reviews__hYrID","showMore":"gallerymodal_showMore___vSNX","scrollBar":"gallerymodal_scrollBar__vPHUZ","close":"gallerymodal_close__FRIYs","commentWrapper":"gallerymodal_commentWrapper__wdkzm"};

/***/ }),

/***/ 82639:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"informer":"informer_informer__t69ra","informerBlock":"informer_informerBlock__q13e9"};

/***/ }),

/***/ 50585:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalReload":"modalReload_modalReload__tK8LW"};

/***/ }),

/***/ 70833:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"openLightBox":"openLightBox_openLightBox__EKwIK"};

/***/ }),

/***/ 19394:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"toolWrapper":"tooltipDiscount_toolWrapper__Pknoz","toolBackdrop":"tooltipDiscount_toolBackdrop__HxcX_","toolInside":"tooltipDiscount_toolInside__BXuBK","toolInsideWhite":"tooltipDiscount_toolInsideWhite__P7kEX","arrow":"tooltipDiscount_arrow__ob4Nb","arrowWhite":"tooltipDiscount_arrowWhite__rWW2l","arrowRight":"tooltipDiscount_arrowRight__0TUj1"};

/***/ }),

/***/ 39429:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"seaRequestMini_main__vMXDV","block":"seaRequestMini_block__MiMJC","blockMissing":"seaRequestMini_blockMissing__DK6GT","formik":"seaRequestMini_formik__a_qjG","formikPhone":"seaRequestMini_formikPhone__y8B1N","formikButton":"seaRequestMini_formikButton__2Hrwz","form":"seaRequestMini_form__E3hHy","mainPage":"seaRequestMini_mainPage__rWw7F","mainPageLink":"seaRequestMini_mainPageLink__3gImF","formikName":"seaRequestMini_formikName__mfORm"};

/***/ })

}]);